import { Box, Container, Link, Toolbar, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom"
import { useAuthService } from "../../../../../use-cases/auth";
import { GeoVelesHeader } from "./GeoVelesHeader";
import { useProjetosService } from "../../../../../use-cases/geo-veles";

function Copyright(props: any) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" href="/">
                Veles
            </Link>
            {' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

export const GeoVelesLayout = () => {
    // Use State
    const [loading, setLoading] = useState<boolean>(true)
    // Hook
    const { setupSession, setToken } = useAuthService()
    const { setProjetosPaginaInicial } = useProjetosService()
    // UseFfect
    useEffect(() => {
        setLoading(false)
    }, [])

    useEffect(() => {
        setToken()
    }, [setToken])

    useEffect(() => {
        setupSession()
    }, [setupSession])

    // Use Effect
    useEffect(() => {
        setProjetosPaginaInicial()
    }, [setProjetosPaginaInicial])



    return (
        <>
            {
                loading ? <></>
                    :
                    <Box sx={{ display: 'flex', height: '100%' }}>
                        <GeoVelesHeader />
                        <Box
                            component="main"
                            sx={{
                                backgroundColor: (theme) =>
                                    theme.palette.mode === 'light'
                                        ? theme.palette.grey[100]
                                        : theme.palette.grey[900],
                                flexGrow: 1,
                                height: '100vh',
                                overflow: 'auto',
                            }}
                        >
                            <Toolbar />
                            <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
                                <Outlet />
                                <Copyright sx={{ pt: 4 }} />
                            </Container>
                        </Box>
                    </Box>
            }
        </>
    )
}